import "../formEditor/Common/FormsCommon";
import "./Fields/BaseRecordField.js";
import "./Fields/CheckboxListRecordInputField.js";
import "./Fields/DateRecordInputField.js";
import "./Fields/DropdownRecordField.js";
import "./Fields/PortfolioDropdownRecordField.js";
import "./Fields/FileAttachRecordInputField.js";
import "./Fields/FormsDatePicker.js";
import "./Fields/HeaderRecordField.js";
import "./Fields/ParagraphRecordField.js";
import "./Fields/RadiobuttonListRecordInputField.js";
import "./Fields/SeparatorRecordField.js";
import "./Fields/SingleLineRecordInputField.js";
import "./Fields/TextAreaRecordInputField.js";
import { customFormsAuditEvents } from "../../AIEvents/customFormsAuditEvents";
import { trackEvent } from "../../common/audit";
import { getFieldsByParent, root, renderFieldWidget, runWidgetFunction } from "../utils/widget";

/* eslint-disable */

(function ($) {
    $.widget("ep.form_record_edit", {
        options: {
            ajax: ep.common.ajax,
            post: ep.common.post,
            get: ep.common.get,

            recordID: 0,
            formID: null,
            resources: {},
            showPreview: false,
            isAnonymous: false,
            getPreviewPostData: function(){},
            urls: {
                newFormRecord: "/FormRecords/New",
                getFormRecord: "/FormRecords/Edit",
                createFormRecord: "/FormRecords/Create",
                updateFormRecord: "/FormRecords/Update",
                preview: "/FormRecords/Preview"
            },

            // ui options
            ui: {
                datepickerButtonImage: ""
            },
            showCancel: true,
            recordFormId: "#record_form",
            setFocus: false,
            showFormTitle: true,
        },

        _create: function () {
            var _this = this;

            // Init internal fields
            this._mode = this.options.recordID == 0 ? 'New' : 'Edit';
            if (this.options.formID == null && this.options.recordID == 0)
            {
                this._mode = 'Preview';
            }

            this._fieldWidgets = [];
            this._showLoadingIndicator();

            var callback = function (postResult) {
                _this._initialize(postResult);
            }

            // Get data from server depending on mode.
            switch(_this._mode){
                case 'New':
                    _this.options.post(
                        _this.options.urls.newFormRecord,
                        { formId: _this.options.formID, isAnonymous: _this.options.isAnonymous },
                        callback,
                        "json",
                        _this._onErrorHandler.bind(_this));
                    break;
                case 'Edit':
                    _this.options.post(
                        _this.options.urls.getFormRecord,
                        { recordID: +_this.options.recordID },
                        callback,
                        "json",
                        _this._onErrorHandler.bind(_this)
                    );
                    break;
                case 'Preview':
                    _this.options.ajax({
                        url: _this.options.urls.preview,
                        type: 'POST',
                        data: JSON.stringify({ formModel: _this.options.getPreviewPostData() }),
                        contentType: 'application/json',
                        async: false,
                        success: function (response) {
                            callback(response);
                        }
                    });
                    break;
            }
        },
        _onErrorHandler: function (e) {
            if (this.options.isAnonymous) {
                var response = JSON.parse(e.responseText || "{}");
                if (response.ErrorType === "ObjectNotFound") {
                    location.reload();
                }
            } else {
                this._trigger("closePopUp");
                ep.common.onAjaxError(e);
            }
        },

        _trackRecordCreatedEvent: function (){

            this._mode === 'New' &&
            trackEvent(customFormsAuditEvents.record.created, {
                "auto convert": this._dataItem.AutoConvertType,
            });

        },

        _initialize: function (data) {
            var _this = this;

            this._dataItem = data.Result;
            this.options.portfolios = data.IsCustomFormPortfolioFieldEnabled ? data.PortfolioFieldOptions : null;
            this._attachments = data.Attachments != undefined ? data.Attachments : [];
            this._culture = data.Culture != undefined ? data.Culture : '';

            if (data.Resources != undefined) {
                this.options.resources = data.Resources;
            }

            // Apply template
            this.element.empty();
            $.tmpl('#form-record-edit-main-tmpl', {
                Data: this._dataItem,
                Resources: this.options.resources,
                Mode: this._mode,
                ShowFormTitle: this.options.showFormTitle
            }).appendTo(this.element);


            _this.$form = $(_this.options.recordFormId);

            // initialize validation
            _this.$form.validate({
                ignore: "",
                errorPlacement: function (error, element) {
                    _this._errorPlacement(error, element);
                }
            });

            // Add children widgets
            var notDeletedItems = [];
            var deletedItems = [];
            $.each(_this._dataItem.Items, function (index, item) {
                if (item.Deleted) {
                    deletedItems.push(item);
                }
                else {
                    if (_this._dataItem.NotifyOnEmailFieldId === item.FieldID) {
                        $.extend(item, { isEmailRecordField: true });
                    }

                    notDeletedItems.push(item);
                }
            });

            // add not deleted items
            var fields = getFieldsByParent(notDeletedItems);
            var container = $("#ul_form_records", _this.element);
            $.each(fields[root] || [], function (index, item) {
                _this._addFieldWidget(container, item, fields);
            });

            // add deleted items
            if (deletedItems.length > 0) {
                $.tmpl('#form-record-deleted', {
                    Resources: _this.options.resources
                }).appendTo(container);

                container = $("#ul-form-records-deleted-elements", _this.element);
                $.each(deletedItems, function (index, item) {
                    _this._addFieldWidget(container, item, fields);
                });
            }

            //Actions
            if (!_this.options.showPreview) {
                this.element.keydown(function (event) {
                    if (event.ctrlKey && event.keyCode === ep.Keys.enter) {
                        event.preventDefault();
                        _this.$form.submit();
                    }
                });
                var $save_btn = $('.save-button', this.element);
                $save_btn.on('click', function () {
                    _this.$form.submit();
                });
                $save_btn.on('keyup', function (event) {
                    if (event.keyCode === ep.Keys.enter) {
                        _this.$form.submit();
                    }
                });
            } else {
                this.element.keydown(function (event) {
                    if (event.keyCode === ep.Keys.enter) {
                        _this._trigger("closePopUp", null, null);
                    }
                });
                $('.close-button', this.element).on('keydown', function (event) {
                    if (event.keyCode === ep.Keys.enter) {
                        _this._trigger("closePopUp", null, null);
                    }
                });
            }
            this.element.keydown(function (event) {
                if (event.keyCode === ep.Keys.esc) {
                    _this._cancelForm();
                }
            });
            $('.close-button', this.element).click(function () {
                _this._cancelForm();
            });

            if (this.options.showCancel) {
                var $cancel_btn = $(".cancel-edit-record");
                $cancel_btn.on('click', function () {
                    _this._cancelForm();
                });
                $cancel_btn.on('keyup', function (event) {
                    if (event.keyCode === ep.Keys.enter) {
                        _this._cancelForm();
                    }
                });
            } else {
                $(".cancel-edit-record").hide();
            };

            this._initializeAjaxForm();
            this._trigger("postBack", null, null);
            this._hideLoadingIndicator();

            if(this.options.setFocus){
                this.element.find(":tabbable:first").focus();
            }
        },
        _cancelForm: function () {
            this._trigger("closePopUp", null, null);
       },
        _errorPlacement: function (error, element) {
            this._fieldWidgets.forEach(runWidgetFunction("errorPlacement", error, element));
        },

        _initializeAjaxForm: function () {
            var _this = this;
            var url = this._mode == 'New' ? this.options.urls.createFormRecord : this.options.urls.updateFormRecord;

            _this.$form.ajaxForm({
                url: url,
                iframe: true,
                dataType: "json",
                global: true,
                beforeSerialize: function () {
                    if (!_this.$form.valid() || _this._inProgress) {
                        return false;
                    }
                    _this._inProgress = true;

                    _this._showLoadingIndicator();
                    _this._showhideCommonLoadingOnThePage(false); //hide progress bar:  hack for bug 10338: 2 progress bar in one time
                    var jsonString = JSON.stringify(_this.getData());
                    $('input[name=recordJson]').val(jsonString);
                },
                success: function (result) {
                    _this._trackRecordCreatedEvent();

                    _this._showhideCommonLoadingOnThePage(true); //return back state of progress bar:  hack for bug 10338: 2 progress bar in one time
                    _this._inProgress = false;
                    // Handle server exception.
                    if (result.ErrorPageUrl != undefined) {
                        _this._processError(result);
                        return;
                    }

                    if (result.UnauthorizedError) {
                        location.reload();
                    }

                    // Apply server validation result.
                    if (!result.Result.IsValid) {
                        _this._applyServerValidationResult(result.Result);
                        return;
                    }

                    // If everything is ok - apply result.
                    _this._dataItem = result.Result;
                    _this._mode = 'Edit';
                    _this._refresh(result);

                    var data = { FormId: _this._dataItem.FormID, RecordId: _this._dataItem.RecordID};
                    _this._trigger('save', null, data);

                    /*Fire unique event for DOM Elements, that form record was seved*/
                    $("body").trigger('form-record-saved', [data]);
                }
            });

        },

        _showhideCommonLoadingOnThePage: function (isShow) {
            var el = $('.progress');
            isShow ? el.show() : el.hide();
        },

        _refresh: function () {
        },

        getMode: function () {
            return this._mode;
        },

        _addFieldWidget: function (container, field, fields) {
            var _this = this;

            var newElement = renderFieldWidget(container, {
                resources: this.options.resources,
                model: field,
                attachments: _this._attachments,
                culture: _this._culture,
                ui: this.options.ui,
                portfolios: this.options.portfolios,
                mode: _this._mode,
                fields,
            });

            // Add to the internal widgets collection.
            this._fieldWidgets.push(newElement);
        },

        _applyServerValidationResult: function (serverResult) {
            this._fieldWidgets.forEach(runWidgetFunction("applyValidationResult", serverResult.Items));
            this._hideLoadingIndicator();
        },

        getData: function () {
            var recordValues = this._fieldWidgets.flatMap(runWidgetFunction("getBranchData")).filter(x => !x.Remove);

            var result = {
                FormID: this._dataItem.FormID,
                RecordID: this._dataItem.RecordID,
                Items: recordValues
            };

            return result;
        },

        getWidgets: function () {
            return this._fieldWidgets;
        },
        _processError: function (result) {
            window.location = result.ErrorPageUrl;
        },

        _showLoadingIndicator: function () {
            $('.form-record-save-cancel-buttons .save-button', this.element).addClass('loading');
        },

        _hideLoadingIndicator: function () {
            $('.form-record-save-cancel-buttons .save-button', this.element).removeClass("loading");
        },

        _destroyChildWidgets: function () {
            this._fieldWidgets.forEach(runWidgetFunction("destroy"));
        },

        destroy: function () {
            this.element.empty();

            $('#FormRecordEditTemplates').remove();

            this._destroyChildWidgets();
            // Call the base destroy function
            $.Widget.prototype.destroy.call(this);
        }
    });
})(jQuery);

/* eslint-enable */
